import React, { useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import "./ApplicantTable.css";
import { format } from "date-fns";
import ShortListRejectButton from "../UI/ShortlistRejectButton/ShortListRejectButton";
import ShortlistPopup from "../ShortlistPopup/ShortlistPopup";
import { updateUserStatus } from "../../service/service";
import toast from "../Toast/toast";
import TableSkeleton from "components/common/Table/TableSkeleton";
import Tooltip from "components/common/Tooltip/Tooltip";

const customStyles = {
  headCells: {
    style: {
      paddingLeft: "1px",
      paddingRight: "1px",
      textAlign: "left",
    },
  },
  cells: {
    style: {
      paddingLeft: "1px",
      paddingRight: "1px",
      textAlign: "left",
    },
  },
};

const ApplicantTable = ({ applicants, projectId, setDisplayApplicants }) => {
  const [isModalOpen, setIsModalOpen] = useState("none");
  const [userId, setUserId] = useState("");

  const handleShortListModalYes = async () => {
    try {
      await updateUserStatus("SHORTLIST", projectId, userId);
      toast.success("Candidate shortlisted!");
      // const arr = applicants.filter((applicant) => applicant.userId !== userId);
      // setDisplayApplicants(arr);
    } catch (error) {
      toast.error("Failed to shortlist candidate.");
      setDisplayApplicants(applicants);
    } finally {
      setIsModalOpen("none");
    }
  };

  const handleRejectModalYes = async () => {
    try {
      await updateUserStatus("REJECTED", projectId, userId);
      toast.success("Candidate rejected.");
      // const arr = applicants.filter((applicant) => applicant.userId !== userId);
      // setDisplayApplicants(arr);
    } catch (error) {
      toast.error("Failed to reject candidate.");
      setDisplayApplicants(applicants);
    } finally {
      setIsModalOpen("none");
    }
  };

  const handleModalNo = () => setIsModalOpen("none");

  const shortListCandidate = (id) => {
    setIsModalOpen("shortList");
    setUserId(id);
  };

  const rejectCandidate = (id) => {
    setIsModalOpen("reject");
    setUserId(id);
  };

  const columns = [
    {
      name: "Applied Date",
      selector: (row) =>
        row.isObserverRow ? "" : format(new Date(row?.appliedAt), "dd/MM/yyyy"),
      cell: (row) =>
        row.isObserverRow ? (
          <div style={{ height: "1px" }} />
        ) : (
          format(new Date(row?.appliedAt), "dd/MM/yyyy")
        ),
      sortable: true,
      width: "8.75rem",
    },
    {
      name: "Applicant Name",
      cell: (row) =>
        row.isObserverRow ? null : (
          <span>
            {row?.name} {row?.lastName}
          </span>
        ),
      sortable: true,
      width: "12.625rem",
    },
    {
      name: "Email Id",
      selector: (row) => (row.isObserverRow ? "" : row?.email),
      width: "18.75rem",
    },
    {
      name: " Work Title",
      // selector: (row) => (row.isObserverRow ? "" : row?.industry?.join(", ")),
      selector: (row) => {
        return row.isObserverRow ? (
          ""
        ) : (
          <Tooltip data={row?.industry?.join(", ")} force={true}>
            {row?.industry?.join(", ")}
          </Tooltip>
        );
      },
      width: "15.5rem",
    },
    {
      name: "View Details",
      cell: (row) =>
        row.isObserverRow ? null : (
          <Link to={`${row?.applicationNumber}`} className="view-btn">
            View Details
          </Link>
        ),
      center: true,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "9.375rem",
    },
    {
      name: "Action",
      cell: (row) =>
        row.isObserverRow ? null : (
          <ShortListRejectButton
            status={row?.applicationStatus}
            shortList={shortListCandidate}
            Reject={rejectCandidate}
            userId={row?.userId}
          />
        ),
      center: true,
      width: "13.75rem",
    },
  ];

  return (
    <>
      <div className="applicant-table-wrapper">
        <DataTable
          columns={columns}
          data={applicants}
          progressComponent={<TableSkeleton columns={columns} />}
          className="custom-data-table"
          customStyles={customStyles}
        />
      </div>

      <ShortlistPopup
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        handleModalNo={handleModalNo}
        handleShortListModalYes={handleShortListModalYes}
        handleRejectModalYes={handleRejectModalYes}
      />
    </>
  );
};

export default ApplicantTable;
